module.exports = "<p-selectButton [options]=\"items\" optionLabel=\"storeName\" [(ngModel)]=\"item\" (onChange)=\"change()\"></p-selectButton>\n"